import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  AppConfigService,
  DictionaryBaseService,
  FeatureService,
  LoggedUserService,
  RouterService,
  SettingsService,
} from '../../services';
import {DictionaryBaseDto} from '../../model';
import {
  ApplicationModule,
  ClaimElementaryRight,
  CompanyElementaryRight,
  ElementaryRight,
  Feature,
  InvoiceCategory,
  PolicyElementaryRight,
  SalesRepElementaryRight,
  UserRole,
} from '../../model/dictionary-ids';
import {InvoiceGuiService} from '../../../bonding/invoice/services/invoice-gui.service';
import {InvoiceItemGuiService} from '../../../bonding/invoice-item/services/invoice-item-gui.service';
import * as $ from 'jquery';
import {InvoiceUtils} from '../../utils/invoice-utils';
import PerfectScrollbar from 'perfect-scrollbar';

@Component({
  selector: 'bon-sidebar',
  templateUrl: './sidebar.component.pug',
})
export class SidebarComponent implements OnInit, OnDestroy {
  readonly accessRodo = ElementaryRight.ACCESS_RODO;
  readonly accessFooter = ElementaryRight.ACCESS_FOOTER;
  readonly userSearch = ElementaryRight.MY_PROFILE_CATEGORY_USERS_SEARCH;
  readonly ElementaryRight = ElementaryRight;
  readonly PolicyElementaryRight = PolicyElementaryRight;
  readonly ClaimElementaryRight = ClaimElementaryRight;
  readonly CompanyElementaryRight = CompanyElementaryRight;
  readonly SalesRepElementaryRight = SalesRepElementaryRight;
  readonly InvoiceCategory = InvoiceCategory;
  readonly UserRole = UserRole;

  invoiceCategories: DictionaryBaseDto[];
  fiNoteCategories: DictionaryBaseDto[];
  module = ApplicationModule;
  scrollbar: PerfectScrollbar;

  showDocumentMenu: boolean;
  showHealthPage = false;

  constructor(
    public settingsService: SettingsService,
    public loggedUserService: LoggedUserService,
    public appService: AppConfigService,
    private dictionaryBaseService: DictionaryBaseService,
    private featureService: FeatureService,
    public router: RouterService,
    private invoiceGuiService: InvoiceGuiService,
    private invoiceItemGuiService: InvoiceItemGuiService
  ) {
    this.settingsService.viewChange.subscribe((moduleId) => {
      this.updateMenuItemsVisibility();
    });
  }

  ngOnInit() {
    this.loadInvoiceCategories();
    this.loadFINoteCategories();
    this.updateMenuItemsVisibility();
    this.initHealtPageVisibility();
    const sidebar: any = $('.sidenav-outer');
    if (sidebar.length > 0) {
      this.scrollbar = new PerfectScrollbar(sidebar[0]);
    }
  }

  ngOnDestroy() {
    if (this.scrollbar) {
      this.scrollbar.destroy();
      this.scrollbar = null;
    }
  }

  initHealtPageVisibility() {
    this.showHealthPage =
      this.settingsService.isModuleActive(this.module.ADMINISTRATION) &&
      this.featureService.get(Feature.REPOSITORY_HEALTH_CHECK);
  }

  updateMenuItemsVisibility() {
    this.showDocumentMenu = !this.settingsService.isModuleActive(
      this.module.ADMINISTRATION,
      this.module.SALES,
      this.module.FINANCE,
      this.module.CLAIM,
      this.module.HR
    );
  }

  getInvoiceCategoryLabel(invoiceCategory: DictionaryBaseDto): string {
    return this.invoiceGuiService.getInvoiceCategoryLabel(invoiceCategory, true);
  }

  getInvoiceItemCategoryLabel(invoiceCategory: DictionaryBaseDto): string {
    return this.invoiceItemGuiService.getInvoiceItemCategoryLabel(invoiceCategory, true);
  }

  private loadInvoiceCategories() {
    this.dictionaryBaseService.getDictionaryBase('InvoiceCategory').subscribe(
      (invoiceCategories) => {
        this.invoiceCategories = invoiceCategories.filter((c) =>
          this.loggedUserService.hasAllRights(InvoiceUtils.getReadRightsNeeded(c.id))
        );
      },
      (error) => {
        alert('Error in backend service: ' + JSON.stringify(error));
      }
    );
  }

  private loadFINoteCategories() {
    this.dictionaryBaseService.getDictionaryBase('FINoteCategory').subscribe(
      (fiNoteCategories) => {
        this.fiNoteCategories = fiNoteCategories.filter((c) =>
          this.loggedUserService.hasAllRights(InvoiceUtils.getReadRightsNeeded(c.id))
        );
      },
      (error) => {
        alert('Error in backend service: ' + JSON.stringify(error));
      }
    );
  }

  showPayments(): boolean {
    return this.loggedUserService.hasRight(ElementaryRight[ElementaryRight.CLIENT_INVOICE_READ]);
  }

  showInvoiceCategory(invoiceCategory: DictionaryBaseDto): boolean {
    return true;
  }

  isSalesRepVisible() {
    const activeModuleCondition = this.settingsService.isModuleActive(this.module.SALES, this.module.POLICY);
    return activeModuleCondition;
  }

  public showTraining(): boolean {
    return this.loggedUserService.isEmployeeOrHasHRRole();
  }
}
